import { Map } from "immutable";

import { ACTIONS } from "features/planner/employee/employee.constants";
import { WorkScheduleOverrideMapper } from "features/planner/planner.mappers";

const initialState = Map();

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_WORK_SCHEDULE_OVERRIDES: {
      if (action.error) return state;

      return Map(
        action.payload.map(Override => [
          Override.workScheduleOverrideId.toString(),
          WorkScheduleOverrideMapper.from(Override),
        ]),
      );
    }

    case ACTIONS.CREATE_WORK_SCHEDULE_OVERRIDE:
    case ACTIONS.UPDATE_WORK_SCHEDULE_OVERRIDE: {
      if (action.error) return state;

      return state.set(
        action.payload.workScheduleOverrideId.toString(),
        WorkScheduleOverrideMapper.from(action.payload),
      );
    }

    case ACTIONS.DELETE_WORK_SCHEDULE_OVERRIDE: {
      if (action.error) return state;

      return state.delete(action.workScheduleOverrideId.toString());
    }

    case ACTIONS.UNLOAD_WORK_SCHEDULE_OVERRIDES: {
      return initialState;
    }

    default:
      return state;
  }
};
